(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["collection-visual-filters"] && !Shopify.designMode) return;
  try {
    
	(function () {
		// Pointer move ≤ this many px = still a click (e.g. open link). Above = horizontal drag; we add grabbing state and block the stray click after release. 8px is a common tap-vs-drag tolerance—not from a design token.
		const dragThresholdPx = 8;

		function init(el) {
			if (el.dataset.vf) return;
			el.dataset.vf = '1';

			el.addEventListener(
				'wheel',
				function (e) {
					if (el.scrollWidth <= el.clientWidth) return;
					const deltaX = e.deltaX;
					const deltaY = e.deltaY;
					let delta = 0;
					if (Math.abs(deltaX) > Math.abs(deltaY)) {
						delta = deltaX;
					} else if (e.shiftKey && deltaY !== 0) {
						delta = deltaY;
					} else {
						return;
					}
					if (!delta) return;
					if (delta < 0 && el.scrollLeft <= 0) return;
					if (delta > 0 && el.scrollLeft + el.clientWidth >= el.scrollWidth - 1) return;
					el.scrollLeft += delta;
					e.preventDefault();
				},
				{ passive: false }
			);

			el.addEventListener('keydown', function (e) {
				if (el.scrollWidth <= el.clientWidth) return;
				const key = e.key;
				if (key !== 'ArrowLeft' && key !== 'ArrowRight' && key !== 'Home' && key !== 'End') return;
				const step = Math.max(Math.round(el.clientWidth * 0.85), 48);
				const maxScroll = el.scrollWidth - el.clientWidth;
				let target = el.scrollLeft;
				if (key === 'ArrowLeft') target -= step;
				else if (key === 'ArrowRight') target += step;
				else if (key === 'Home') target = 0;
				else if (key === 'End') target = maxScroll;
				target = Math.max(0, Math.min(target, maxScroll));
				if (target !== el.scrollLeft) {
					el.scrollLeft = target;
					e.preventDefault();
				}
			});

			let isPointerDown = false;
			let startClientX = 0;
			let startScrollLeft = 0;
			let totalMovePx = 0;
			let lastClientX = 0;
			let rafId = null;
			let dragClassOn = false;

			function applyScrollFromPointer() {
				rafId = null;
				if (!isPointerDown) return;
				const deltaPx = lastClientX - startClientX;
				totalMovePx = Math.abs(deltaPx);
				el.scrollLeft = startScrollLeft - deltaPx;
				if (totalMovePx > dragThresholdPx && !dragClassOn) {
					dragClassOn = true;
					el.classList.add('is-dragging-scroll');
				}
			}

			function onPointerMove(e) {
				if (!isPointerDown) return;
				lastClientX = e.clientX;
				if (rafId === null) rafId = requestAnimationFrame(applyScrollFromPointer);
			}

			function onPointerUp() {
				if (!isPointerDown) return;
				if (rafId !== null) {
					cancelAnimationFrame(rafId);
					rafId = null;
				}
				totalMovePx = Math.abs(lastClientX - startClientX);
				el.scrollLeft = startScrollLeft - (lastClientX - startClientX);
				isPointerDown = false;
				dragClassOn = false;
				el.classList.remove('is-dragging-scroll');
				document.removeEventListener('mousemove', onPointerMove);
				document.removeEventListener('mouseup', onPointerUp);
				if (totalMovePx <= dragThresholdPx) {
					el.scrollLeft = startScrollLeft;
					return;
				}
				document.addEventListener(
					'click',
					function suppressClickAfterDrag(e) {
						if (!el.contains(e.target)) {
							document.removeEventListener('click', suppressClickAfterDrag, true);
							return;
						}
						e.preventDefault();
						e.stopPropagation();
						document.removeEventListener('click', suppressClickAfterDrag, true);
					},
					true
				);
			}

			el.addEventListener('mousedown', function (e) {
				if (e.button !== 0 || el.scrollWidth <= el.clientWidth) return;
				isPointerDown = true;
				startClientX = lastClientX = e.clientX;
				startScrollLeft = el.scrollLeft;
				totalMovePx = 0;
				dragClassOn = false;
				document.addEventListener('mousemove', onPointerMove);
				document.addEventListener('mouseup', onPointerUp);
			});
		}

		function run() {
			const nodes = document.querySelectorAll('[data-visual-filters-scroll]');
			for (let i = 0; i < nodes.length; i++) init(nodes[i]);
		}

		if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', run, { once: true });
		else run();
		document.addEventListener('shopify:section:load', run);
	})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
